/**
 * 隐私条款页面入口
 * 复用 Navbar / Footer 组件，主体为条款内容渲染
 */
import '../../styles/global.css';
import {
  Navbar,
  Footer,
  BRAND,
  NAV_LINKS,
  FOOTER_LINKS,
  COPYRIGHT,
  scrollToHash,
} from '../../components';
import { PRIVACY_META, PRIVACY_SECTIONS } from './content';

// ─── 渲染目录 TOC ───
function renderToc() {
  return `
    <nav class="toc-card" aria-label="目录">
      <div class="toc-card__title">目录</div>
      <ul class="toc-card__list">
        ${PRIVACY_SECTIONS.map(
          (s) => `<li><a href="#${s.id}">${s.heading}</a></li>`
        ).join('')}
      </ul>
    </nav>
  `;
}

// ─── 渲染章节列表 ───
function renderList(list) {
  if (!list || list.length === 0) return '';
  const items = list
    .map((item) => {
      if (typeof item === 'string') return `<li>${item}</li>`;
      return `<li><strong>${item.label}：</strong>${item.desc}</li>`;
    })
    .join('');
  return `<ul>${items}</ul>`;
}

// ─── 渲染主体 ───
function renderBody() {
  return PRIVACY_SECTIONS.map((section) => {
    const before = (section.paragraphs || []).map((p) => `<p>${p}</p>`).join('');
    const after = (section.paragraphsAfter || []).map((p) => `<p>${p}</p>`).join('');
    return `
      <section id="${section.id}">
        <h2>${section.heading}</h2>
        ${before}
        ${renderList(section.list)}
        ${after}
      </section>
    `;
  }).join('');
}

// ─── 页面组装 ───
function renderPage() {
  const root = document.getElementById('app');
  if (!root) return;

  // Navbar
  const navbar = new Navbar({
    brand: BRAND,
    links: NAV_LINKS,
    activeKey: 'privacy',
  });
  root.appendChild(navbar.render());

  // Legal main
  const main = document.createElement('main');
  main.className = 'legal';
  main.innerHTML = `
    <div class="container">
      <div class="legal__inner">
        <header class="legal__header">
          <h1 class="heading-lg">${PRIVACY_META.title}</h1>
          <span class="legal__updated">最近更新：${PRIVACY_META.updated}</span>
        </header>
        ${renderToc()}
        <article class="legal__body">
          ${renderBody()}
        </article>
      </div>
    </div>
  `;
  root.appendChild(main);

  // Footer
  const footer = new Footer({
    copyright: COPYRIGHT,
    links: FOOTER_LINKS,
  });
  root.appendChild(footer.render());

  // 正文进入 DOM 后补一次目录锚点定位
  scrollToHash();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderPage);
} else {
  renderPage();
}
